<template>
  <v-app>
    <layout />
    <v-snackbar
      v-model="display"
      :top="!snackbarBottom"
      :bottom="snackbarBottom"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
    >
      {{ snackbarText }}
      <v-btn
        text
        @click="closeNoti"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        display: false,
      }
    },
    computed: {
      snackbarVisible () {
        return this.$store.getters.snackbarVisible
      },
      snackbarColor () {
        return this.$store.getters.snackbarColor
      },
      snackbarTimeout () {
        return this.$store.getters.snackbarTimeout
      },
      snackbarText () {
        return this.$store.getters.snackbarText
      },
      snackbarBottom () {
        return this.$store.getters.snackbarBottom
      },
    },
    watch: {
      snackbarVisible (newVal) {
        this.display = newVal
      },
      display (newVal) {
        if (newVal === false) {
          this.closeNoti()
        }
      },
    },
    methods: {
      closeNoti () {
        this.$store.commit('setSnackbarVisible', false)
      },
    },
  }
</script>
